import { Progress, Space, Typography } from 'antd'
import CIMSSection from 'components/CIMSSection'
import {
  BatchReportJobProgressStage,
  type QueuedBatchReportJobsQuery,
} from 'schema'

type ProgressDetails = NonNullable<
  QueuedBatchReportJobsQuery['listBatchReportJobs']['records'][number]['progress']
>

interface BatchReportJobStatusProps {
  progress: ProgressDetails | null
}

function BatchReportJobStatus({ progress }: BatchReportJobStatusProps) {
  const percent = progressPercent(progress)
  return (
    <CIMSSection title="Status">
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <Typography.Text>{statusMessage(progress)}</Typography.Text>
        <Progress
          percent={percent}
          showInfo={progress !== null && progress.totalRecords !== null}
          status={
            progress?.stage === BatchReportJobProgressStage.Generating
              ? 'active'
              : undefined
          }
        />
      </Space>
    </CIMSSection>
  )
}

function progressPercent(progress: ProgressDetails | null) {
  if (!progress) return 0
  const { processedRecords, totalRecords } = progress
  if (processedRecords === null || totalRecords === null || totalRecords === 0)
    return 0
  return Math.min(100, Math.round((processedRecords / totalRecords) * 100))
}

function statusMessage(progress: ProgressDetails | null) {
  if (!progress) return 'Status temporarily unavailable. Retrying...'
  if (progress.stage === BatchReportJobProgressStage.Preparing)
    return 'Preparing export records...'
  const count =
    progress.processedRecords === null || progress.totalRecords === null
      ? ''
      : ` Processed ${progress.processedRecords.toLocaleString()} of ${progress.totalRecords.toLocaleString()} records.`
  if (progress.stage === BatchReportJobProgressStage.Generating)
    return `Generating reports.${count}`
  return `Finalizing the export archive.${count}`
}

export default BatchReportJobStatus
